









import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    name: "TooltipLabel"
})
export default class extends Vue{
    @Prop({type: String, default: ""}) readonly value!: string;
}
